// theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#333', // dark grey color
    },
    secondary: {
      main: '#fff', // white color
    },
    background: {
      default: '#f5f5f5', // light grey background
      paper: '#fff', // white paper background
    },
    text: {
      primary: '#333', // dark grey text
      secondary: '#1a1b26', // white text
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          // Make buttons look flat and round
          boxShadow: 'none',
          borderRadius: 20, // Adjust the value to control the roundness
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          // color: 'your_checkbox_color', // Change this to your desired checkbox color
          // border: '1px solid #ccc', // Add border style here
          // borderRadius: '4px', // Optional: Add border radius for a rounded look
          '&$checked': {
            color: 'your_checked_checkbox_color', // Change this to your desired checked checkbox color
          },
        },
      },
    },
    // MuiTextField: {
    //   styleOverrides: {
    //     root: {
    //       // Outline text fields
    //       '& .MuiOutlinedInput-root': {
    //         '&.Mui-focused fieldset': {
    //           borderColor: '#333', // Dark grey color when focused
    //         },
    //       },
    //     },
    //   },
    // },
    MuiInputBase: {
      styleOverrides: {
        // Apply styles to all text field-type components
        '&.MuiOutlinedInput-root, &.MuiTextareaAutosize-root, &.MuiInputBase-root': {
          border: '1px solid #333', // Dark grey color for the outline
          borderRadius: '4px', // Adjust the value to control the roundness
          padding: '8px', // Adjust the padding as needed
        },
        // Apply styles to focused state
        // '&.Mui-focused': {
        //   borderColor: '#333', // Dark grey color when focused
        // },
      },
    },
    MuiTextField: {
        styleOverrides: {
          notchedOutline: {
            border: '1px solid black',
          },
        },
      },
      MuiTextareaAutosize: {
        styleOverrides: {
          textarea: {
            border: '1px solid black',
          },
        },
      },
  },
});

export default theme;
